module.exports = __webpack_public_path__ + "img/IMG-20200301-WA0306.f96160e4.jpg";